import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitEnquiry = (data) =>
  axios.post(`${API}/enquiries`, data).then((r) => r.data);
